// Texts for the world 'moles': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks it); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Muldvarpeby',
    scene: { dig: 'GRAV!' },
    levels: {
      'up-the-lift': { title: 'Op med elevatoren' },
      'mine-cart': { title: 'Minevognen' },
      'rope-pulls': { title: 'Rebet trækker' },
      'heavy-or-light': { title: 'Tung eller let' },
      'into-the-deep': { title: 'Ned i dybet' },
      'two-crystals': { title: 'To krystaller' },
      'uphill': { title: 'Op ad bakke' },
      'follow-the-rope': { title: 'Følg rebet' },
      'hatch': { title: 'Lågen' },
      'up-or-down': { title: 'Op eller ned' },
      'coal-on-the-lift': { title: 'Kul på liften' },
      'two-floors': { title: 'To etager' },
      'lift-and-hatch': { title: 'Lift og låge' },
      'mushroom-hop': { title: 'Svampehop' },
      'master-mine': { title: 'Mesterminen' },
    },
  },
  en: {
    name: 'Mole town',
    scene: { dig: 'DIG!' },
    levels: {
      'up-the-lift': { title: 'Up in the lift' },
      'mine-cart': { title: 'The mine cart' },
      'rope-pulls': { title: 'The rope pulls' },
      'heavy-or-light': { title: 'Heavy or light' },
      'into-the-deep': { title: 'Into the deep' },
      'two-crystals': { title: 'Two crystals' },
      'uphill': { title: 'Uphill' },
      'follow-the-rope': { title: 'Follow the rope' },
      'hatch': { title: 'The hatch' },
      'up-or-down': { title: 'Up or down' },
      'coal-on-the-lift': { title: 'Coal on the lift' },
      'two-floors': { title: 'Two floors' },
      'lift-and-hatch': { title: 'Lift and hatch' },
      'mushroom-hop': { title: 'Mushroom hop' },
      'master-mine': { title: 'The master mine' },
    },
  },
});
